import { render, staticRenderFns } from "./ApplicantCandidateRoles.vue?vue&type=template&id=a0537eea"
import script from "./ApplicantCandidateRoles.vue?vue&type=script&lang=js"
export * from "./ApplicantCandidateRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports